import { render, staticRenderFns } from "./cell-box.vue?vue&type=template&id=2a143c8b&"
import script from "./cell-box.vue?vue&type=script&lang=js&"
export * from "./cell-box.vue?vue&type=script&lang=js&"
import style0 from "./cell-box.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cell-box.vue"
export default component.exports